import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AGGREGATE_NAMES, LOAN_REQUEST_COMMANDS } from 'cpool-constants';
import type { APPLICANT_ATTRIBUTIONS } from 'cpool-constants';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { APICommunicator } from '~/api/APICommunicator';
import { setQueryPosition } from '~/store/queryPositionStore';

export const useDemandDocumentsMutation = () => {
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async ({
            attribution,
            documents,
            leadId,
        }: {
            attribution: keyof typeof APPLICANT_ATTRIBUTIONS;
            documents: string[];
            leadId: string;
        }) =>
            APICommunicator.sendCommand({
                aggregateId: leadId,
                aggregateName: AGGREGATE_NAMES.LOAN_REQUEST,
                commandName: LOAN_REQUEST_COMMANDS.demandDocuments,
                payload: {
                    attribution,
                    documents,
                },
            }),
        onError: () => toast.error(t('LEAD_DETAILS_GENERAL.EMAIL_ERROR')),
        onSuccess: async (data, { leadId }) => {
            toast.success(t('LEAD_DETAILS_GENERAL.EMAIL_SUCCESSFULLY'));
            const queryKey = ['loan-request', 'getDemandedDocuments', { id: leadId }];
            setQueryPosition(JSON.stringify(queryKey), data.position);
            await queryClient.invalidateQueries({ queryKey: ['loan-request', 'getDemandedDocuments'] });
        },
    });
};
